// import Masonry from 'masonry-layout';
import Isotope from 'isotope-layout';
import 'isotope-packery';
import imagesLoaded from 'imagesloaded';
import '@fancyapps/fancybox';

let $ = jQuery;
let iso;

function calculateColumnWidths() {
    const columnWidths = {};
    const viewportWidth = window.innerWidth;

    for (let i = 2; i <= 6; i++) {
        columnWidths[i] = [];
        for (let j = 1; j < i; j++) {
            let width = (100 / i) * j;
            //Maximum columns width is 67%
            if (width <= 67){
                columnWidths[i].push(width);
            }
        }
    }

    if (viewportWidth <= 600) {
        columnWidths[2] = [50, 100];
    }
    return columnWidths;
}

let currentRowWidths = [];
let currentColumn = 0;
let hundredPercentCounter = 0;

function loadImage(item, columnWidths, columns) {
    return new Promise((resolve) => {
        let img = item.querySelector('img');
        let image = new Image();
        image.src = img.src;

        image.onload = function() {
            let aspectRatio = this.width / this.height;
            let widths = columnWidths[columns];
            let itemWidthPercent = widths[Math.floor(Math.random() * widths.length)];

            // Mobile image sizes should be 50 / 100%
            if (window.innerWidth <= 600) {
                if (hundredPercentCounter >= 1) {
                    itemWidthPercent = 50;
                    hundredPercentCounter = 0;
                } else {
                    itemWidthPercent = [50, 100][Math.floor(Math.random() * 2)];
                    if (itemWidthPercent === 100) {
                        hundredPercentCounter++;
                    } else {
                        hundredPercentCounter = 0;
                    }
                }
            } else {
                itemWidthPercent = widths[Math.floor(Math.random() * widths.length)];
            }

            // If this is the last item in the row or the only width that fits
            // if (currentColumn === columns - 1 || widths[currentColumn] > 100 - currentRowWidths.reduce((a, b) => a + b, 0)) {
            //     // Set the width to the remaining space to make the total 100%
            //     itemWidthPercent = 100 - currentRowWidths.reduce((a, b) => a + b, 0);
            //     // Reset the widths for the next row
            //     currentRowWidths = [];
            //     currentColumn = 0;
            // } else {
            //     // Select the next width in the array
            //     itemWidthPercent = widths[currentColumn];
            //     // Store the width for the current row
            //     currentRowWidths.push(itemWidthPercent);
            //     currentColumn++;
            // }

            setItemDimensions(item, itemWidthPercent, aspectRatio);
            resolve();
        };
    });
}

// function determineItemWidth(imageWidth, widths) {
    // if (imageWidth <= 500) {
    //     return widths[0];
    // } else if (imageWidth <= 1000) {
    //     return widths[Math.floor(widths.length / 2)];
    // } else {
    //     return widths[widths.length - 1];
    // }
//     return widths[Math.floor(Math.random() * widths.length)];
// }

function setItemDimensions(item, itemWidthPercent, aspectRatio) {
    item.setAttribute('data-gallery-item', itemWidthPercent);
    item.style.setProperty('--gallery-item-width', `${itemWidthPercent}%`);
    // item.style.setProperty('--gallery-item-height', `${itemWidthPercent / aspectRatio}%`);
}

function initializeFancybox() {
    $('[data-fancybox="gallery"]').fancybox({
        infobar: false,
        buttons: [
            'zoom',
            'share',
            'slideShow',
            'fullScreen',
            'download',
            'thumbs',
            'close',
        ],
        animationEffect: 'zoom',
        transitionEffect: 'slide',
    });
}

function handleFilterChange(event, gallery) {
    const selectedCategory = event.target.value;
    iso.arrange({
        filter: (index, itemElem) => {
            const imgElem = itemElem.querySelector('img');
            const rawCategories = imgElem.getAttribute('data-categories');
            const categories = rawCategories
                .split(',')
                .map(category => category.trim().toLowerCase());
            const match = selectedCategory === 'all' || categories.includes(selectedCategory.toLowerCase());
            return match;
        },
    });

    iso.on('arrangeComplete', function(visibleItems) {
        const noImages = gallery.nextElementSibling;
        if (visibleItems.length === 0) {
            noImages.setAttribute('data-no-gallery-images', 'active');
        } else {
            noImages.setAttribute('data-no-gallery-images', 'inactive');
        }

        $.fancybox.close();
        $('[data-fancybox="gallery"]:visible').fancybox({
            infobar: false,
            buttons: [
                'zoom',
                'share',
                'slideShow',
                'fullScreen',
                'download',
                'thumbs',
                'close',
            ],
            animationEffect: 'zoom',
            transitionEffect: 'slide',
        });
    });

}

jQuery(document).ready(function($) {
    const galleryBlocks = document.querySelectorAll('[data-gallery]');
    if (galleryBlocks.length === 0) {
        return;
    }

    const columnWidths = calculateColumnWidths();
    console.log(columnWidths);

    galleryBlocks.forEach((gallery) => {
        imagesLoaded(gallery, function() {
            
            const columns = gallery.dataset.galleryColumns;
            const columnWidthPercent = 100 / columns;            
            const sizer = gallery.querySelector('[data-gallery-sizer]');
            sizer.style.width = `${columnWidthPercent}%`;

            const items = gallery.querySelectorAll('[data-gallery-item]');
            const loadPromises = Array.from(items).map(item => loadImage(item, columnWidths, columns));

            Promise.all(loadPromises).then(() => {
                iso = new Isotope(gallery, {
                    itemSelector: '[data-gallery-item]',
                    percentPosition: true,
                    layoutMode: 'masonry',
                    masonry: {
                        columnWidth: sizer,
                        gutter: 0,
                    }
                });
                
                initializeFancybox();
            });
            
        });

        const galleryFilterContainer = gallery.parentElement.querySelector('[data-gallery-filter]');
        if (galleryFilterContainer) {
            const select = galleryFilterContainer.querySelector('#category-select');
            select.addEventListener('change', (e) => handleFilterChange(e, gallery));
        }
    });
});